import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// action
import { registerUser, apiError, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

//import images
import logoWhite from "../../assets/images/crm-expert-logo-white.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

import "./login-modern.scss";

const Register = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const [formStatus, setFormStatus] = useState(null);
    const [passwordShow, setPasswordShow] = useState(false);
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
            first_name: '',
            password: '',
            confirm_password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            first_name: Yup.string().required("Please Enter Your Username"),
            password: Yup.string().required("Please enter your password"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref("password")], "Passwords do not match")
                .required("Please confirm your password"),
        }),
        onSubmit: async (values) => {
            if (process.env.REACT_APP_API_URL) {
                dispatch(registerUser(values));
                return;
            }

            const users = JSON.parse(localStorage.getItem('velzonUsers') || '[]');
            const duplicate = users.some((user) => user.email.toLowerCase() === values.email.toLowerCase());
            if (duplicate) {
                setFormStatus({ type: 'danger', message: 'This email is already registered.' });
                return;
            }
            users.push({ email: values.email, first_name: values.first_name, password: values.password });
            localStorage.setItem('velzonUsers', JSON.stringify(users));
            setFormStatus({ type: 'success', message: 'Registration successful! Redirecting to login...' });
            setTimeout(() => history('/login'), 1800);
        }
    });


    const selectLayoutState = (state) => state.Account;
    const registerdatatype = createSelector(
        selectLayoutState,
        (account) => ({
            success: account.success,
            error: account.error
        })
    );
    // Inside your component
    const {
        error, success
    } = useSelector(registerdatatype);

    useEffect(() => {
        dispatch(apiError(""));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            setTimeout(() => history("/login"), 3000);
        }

        setTimeout(() => {
            dispatch(resetRegisterFlag());
        }, 3000);

    }, [dispatch, success, error, history]);

    document.title = "CRM Expert Sign Up | CRM Expert Dashboard";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-center">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>

                                <div className="auth-center__logo">
                                    <img src={logoWhite} alt="CRM Expert" height="80" />
                                </div>

                                <Card className="auth-center-card">
                                    <CardBody>
                                        <div className="auth-center-card__header">
                                            <h4>Create your account</h4>
                                            <p>Start managing customers, leads and sales faster.</p>
                                        </div>

                                        {formStatus ? (
                                            <Alert color={formStatus.type} className="auth-alert">{formStatus.message}</Alert>
                                        ) : null}

                                        {success && success ? (
                                            <>
                                                {toast("Your Redirect To Login Page...", { position: "top-right", hideProgressBar: false, className: 'bg-success text-white', progress: undefined, toastId: "" })}
                                                <ToastContainer autoClose={2000} limit={1} />
                                                <Alert color="success" className="auth-alert">
                                                    Register User Successfully and Your Redirect To Login Page...
                                                </Alert>
                                            </>
                                        ) : null}

                                        {error && error ? (
                                            <Alert color="danger" className="auth-alert">
                                                Email has been Register Before, Please Use Another Email Address...
                                            </Alert>
                                        ) : null}

                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            className="needs-validation"
                                        >
                                            <div className="auth-field">
                                                <Label htmlFor="email" className="auth-label">Email <span className="text-danger">*</span></Label>
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    className="auth-input"
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={validation.touched.email && !!validation.errors.email}
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-field">
                                                <Label htmlFor="first_name" className="auth-label">Username <span className="text-danger">*</span></Label>
                                                <Input
                                                    id="first_name"
                                                    name="first_name"
                                                    type="text"
                                                    className="auth-input"
                                                    placeholder="Enter username"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.first_name || ""}
                                                    invalid={validation.touched.first_name && !!validation.errors.first_name}
                                                />
                                                {validation.touched.first_name && validation.errors.first_name ? (
                                                    <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-field">
                                                <Label htmlFor="password" className="auth-label">Password <span className="text-danger">*</span></Label>
                                                <div className="auth-pass-wrap">
                                                    <Input
                                                        id="password"
                                                        name="password"
                                                        type={passwordShow ? "text" : "password"}
                                                        className="auth-input"
                                                        placeholder="Enter Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.password || ""}
                                                        invalid={validation.touched.password && !!validation.errors.password}
                                                    />
                                                    <button
                                                        className="auth-pass-toggle"
                                                        type="button"
                                                        aria-label={passwordShow ? "Hide password" : "Show password"}
                                                        onClick={() => setPasswordShow(!passwordShow)}
                                                    >
                                                        <i className={passwordShow ? "ri-eye-off-fill" : "ri-eye-fill"} />
                                                    </button>
                                                </div>
                                                {validation.touched.password && validation.errors.password ? (
                                                    <FormFeedback type="invalid" className="d-block">{validation.errors.password}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-field">
                                                <Label htmlFor="confirm_password" className="auth-label">Confirm Password <span className="text-danger">*</span></Label>
                                                <div className="auth-pass-wrap">
                                                    <Input
                                                        id="confirm_password"
                                                        name="confirm_password"
                                                        type={confirmPasswordShow ? "text" : "password"}
                                                        className="auth-input"
                                                        placeholder="Confirm Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.confirm_password || ""}
                                                        invalid={validation.touched.confirm_password && !!validation.errors.confirm_password}
                                                    />
                                                    <button
                                                        className="auth-pass-toggle"
                                                        type="button"
                                                        aria-label={confirmPasswordShow ? "Hide password" : "Show password"}
                                                        onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                                                    >
                                                        <i className={confirmPasswordShow ? "ri-eye-off-fill" : "ri-eye-fill"} />
                                                    </button>
                                                </div>
                                                {validation.touched.confirm_password && validation.errors.confirm_password ? (
                                                    <FormFeedback type="invalid" className="d-block">{validation.errors.confirm_password}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-terms">
                                                By registering you agree to CRM Expert's{" "}
                                                <Link to="#" className="auth-link">Terms of Use</Link>
                                            </div>

                                            <button className="auth-submit" type="submit">Create Account</button>

                                            <div className="auth-divider">
                                                <span>or continue with</span>
                                            </div>

                                            <div className="auth-social">
                                                <button type="button" className="auth-social__btn" aria-label="Sign up with Facebook">
                                                    <i className="ri-facebook-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" aria-label="Sign up with Google">
                                                    <i className="ri-google-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" aria-label="Sign up with GitHub">
                                                    <i className="ri-github-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" aria-label="Sign up with Twitter">
                                                    <i className="ri-twitter-fill" />
                                                </button>
                                            </div>
                                        </Form>

                                        <div className="auth-signup">
                                            Already have an account? <Link to="/login">Sign in</Link>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default Register;